export const UserActivityGetters = {
  UserActivityList: 'UserActivityGetters.UserActivityList',
  UserActivityForMenu: 'UserActivityGetters.UserActivityForMenu',
  UserActivityPerPage: 'UserActivityGetters.UserActivityPerpage',
  UserActivityListingOffset: 'UserActivityGetters.UserActivityListingOffset',
  UserActivityFilteredRecordCount: 'UserActivityGetters.UserActivityFilteredRecordCount',
  SortBy: 'UserActivityGetters.SortBy',
  SortDirection: 'UserActivityGetters.SortDirection'
};

export const UserActivityActions = {
  RetrieveUserActivityForMenu: 'UserActivityActions.RetrieveUserActivityForMenu',
  RetrieveUserActivityList: 'UserActivityActions.RetrieveUserActivityList',
  RetrieveUserActivityFilteredRecordCount:
    'UserActivityActions.RetrieveUserActivityFilteredRecordCount',
  FilterUserActivity: 'UserActivityActions.FilterUserActivity',
  SetUserActivitySortOrder: 'UserActivityActions.SetUserActivitySortOrder',
  SetUserActivityPaginationParameters: 'UserActivityActions.SetUserActivityPaginationParameters',
  DeleteUserActivity: 'UserActivityActions.DeleteUserActivity'
};

export const UserActivityMutations = {
  SetUserActivityForMenu: 'UserActivityMutations.SetUserActivityForMenu',
  SetUserActivityList: 'UserActivityMutations.SetUserActivityList',
  SetUserActivityFilteredRecordCount: 'UserActivityMutations.SetUserActivityFilteredRecordCount',
  FilterUserActivity: 'RecentitemsMutations.FilterUserActivity',
  SetUserActivitySortOrder: 'UserActivityMutations.SetUserActivitySortOrder',
  SetUserActivityPaginationParameters: 'UserActivityMutations.SetUserActivityPaginationParameters',
  ResetUserActivityPaginationOffset: 'UserActivityMutations.ResetUserActivityPaginationOffset',
  SetUserActivitySearchParam: 'UserActivityMutations.SetUserActivitySearchParam',
  SetUserActivityLoading: 'UserActivityMutationsSetUserActivityLoading'
};
